let url_update_proveedor = "/update-password";
let url_login = "/";
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000
});

$(document).ready(function(){
    $(document).on('click','#actualizar-contrasena',function(e){
        e.preventDefault();
        $(this).attr("disabled", true);
        //verificamos que las dos contraseñas coincidan
        if($("#password").val() != $("#repeat-password").val())
        {
            console.log("las contraseñas no coinciden");
            $("#password").addClass("is-invalid");
            $("#repeat-password").addClass("is-invalid");
            $("#error-password").html('las contraseñas no coinciden');
            return false;
        }
        axios.post(url_update_proveedor,{
            password         : $('#password').val(),
            token            : $('#token').val()
        })
        .then(response =>{
            console.log(response.data);
            Toast.fire({
                icon: 'success',
                title: '<h4>Contraseña actualizada correctamente</h4>'
            })
            setTimeout(redirigir,4000);    
        })
    });
});

function redirigir()
{
    location.href = url_login;
}
